<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_40 col_20'><span class='brt high default' id='text1'>NATIONAL RAILROAD  PASSENGER CORPORATION</span>  </div>
  <div class='lgr_05 col_75'><span class='default' id='text2'>S143G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><dynamic-field [id]='"scrntm"' [size]=8 [line]=2 [column]=1 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_40 col_20'><span class='brt high default' id='text3'>DATE WEIGHTING FACTOR MAINTENANCE SCREEN</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_40 col_20'><span class='brt high default' id='text4'>----------------------------------------</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_55 col_01'><span class='brt high default' id='text5'>ENTER REQUIRED FIELDS AND HIT APPROPRIATE FUNCTION KEY:</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_55 col_01'><span class='brt high default' id='text6'>-------------------------------------------------------</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_25 col_01'><span class='default' id='text7'>TRAIN DATE (YYYY-MM-DD): </span>  </div>
  <div class='lgr_10 col_32'><dynamic-field [id]='"traindt"' [size]=10 [line]=9 [column]=32 [(ngModel)]='traindt'></dynamic-field></div>
  <div class='lgr_00 col_43'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_21 col_01'><span class='default' id='text9'>DATE WEIGHT FACTOR : </span>  </div>
  <div class='lgr_01 col_32'><dynamic-field [id]='"dtwtftr"' [size]=1 [line]=11 [column]=32 [(ngModel)]='dtwtftr'></dynamic-field></div>
  <div class='lgr_01 col_34'><span class='default' id='text10'>.</span>  </div>
  <div class='lgr_02 col_36'><dynamic-field [id]='"dtwtdec"' [size]=2 [line]=11 [column]=36 [(ngModel)]='dtwtdec'></dynamic-field></div>
  <div class='lgr_00 col_39'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><span class='default' id='text12'>PF3=EXIT</span>  </div>
  <div class='lgr_10 col_12'><span class='default' id='text13'>PF4=RETURN</span>  </div>
  <div class='lgr_07 col_25'><span class='default' id='text14'>PF5=ADD</span>  </div>
  <div class='lgr_10 col_35'><span class='default' id='text15'>PF6=UPDATE</span>  </div>
</div>
</div>
